module.exports = __webpack_public_path__ + "static/undraw_youtube_tutorial_2gn3-e0bc2c37126c97a57e82c570d7b542a4.svg";